<template>
  <div></div>
</template>
<script>
import CryptoJS from "@/util/crypto-js.mini.js";
import { hex_md5 } from "@/util/md5.js";
let ttsWS;
export default {
  data() {
    return {
      APPID: window._CONFIG.XUNFEI_AUDIO.APPID,
      API_KEY: window._CONFIG.XUNFEI_AUDIO.API_KEY,
      API_SECRET: window._CONFIG.XUNFEI_AUDIO.API_SECRET,

      hasClick: false,
      isShowRecordPanel: false,
      btnStatus: "LISTEN", // "UNDEFINED" "CONNECTING" "PLAY" "STOP"

      audio: null,
      audioToTextTempResult: "",
      audioToTextResult: "",

      audioPlayer: null,
      ttsWS: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let self = this;

      this.btnStatus = "UNDEFINED"; // "UNDEFINED" "CONNECTING" "PLAY" "STOP"

      const audioPlayer = new AudioPlayer("xunfei-audioplayer/");
      this.audioPlayer = audioPlayer;
      audioPlayer.onPlay = () => {
        console.log("正在说话");

        self.$store.commit("setIsSpeaking", true);
      };
      audioPlayer.onStop = (audioDatas) => {
        console.log("说话暂停");
        self.$store.commit("setIsSpeaking", false);
      };
      audioPlayer.onEnd = () => {
        console.log("播放结束");
        self.$store.commit("setIsSpeaking", false);
        // this.onSpeechEnd(); // 添加播放结束事件
      };
    },
    speak(str) {
      this.stop(); // 停止之前的合成和播放
      // 开始合成
      this.connectWebSocketToSpeak(str);
      return this.audioPlayer;
    },
    stop(str) {
      this.ttsWS && this.ttsWS.close();
      this.audioPlayer && this.audioPlayer.reset();
    },

    encodeText(text, type) {
      if (type === "unicode") {
        let buf = new ArrayBuffer(text.length * 4);
        let bufView = new Uint16Array(buf);
        for (let i = 0, strlen = text.length; i < strlen; i++) {
          bufView[i] = text.charCodeAt(i);
        }
        let binary = "";
        let bytes = new Uint8Array(buf);
        let len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
      } else {
        return CryptoJS.enc.Base64.encode(text);
      }
    },

    connectWebSocketToSpeak(text) {
      console.log("connectWebSocketToSpeak", text);
      const url = this.getWebSocketUrl(this.API_KEY, this.API_SECRET);
      if ("WebSocket" in window) {
        ttsWS = new WebSocket(url);
      } else if ("MozWebSocket" in window) {
        ttsWS = new MozWebSocket(url);
      } else {
        alert("浏览器不支持WebSocket");
        return;
      }
      this.changeBtnStatus("CONNECTING");

      ttsWS.onopen = (e) => {
        this.audioPlayer.start({
          autoPlay: true,
          sampleRate: 16000,
          resumePlayDuration: 1000,
        });
        this.changeBtnStatus("PLAY");
        var tte = "unicode"; //"UTF8" // ;
        var params = {
          common: {
            app_id: this.APPID,
          },
          business: {
            aue: "raw",
            auf: "audio/L16;rate=16000",
            vcn: "xiaoyan", //  "xiaoyan" "aisbabyxu","xiaoyu";
            speed: 50,
            volume: 50,
            pitch: 50,
            bgs: 0,
            tte,
          },
          data: {
            status: 2,
            text: this.encodeText(text, tte),
          },
        };
        ttsWS.send(JSON.stringify(params));
      };
      ttsWS.onmessage = (e) => {
        let jsonData = JSON.parse(e.data);
        // 合成失败
        if (jsonData.code !== 0) {
          console.error(jsonData);
          this.changeBtnStatus("UNDEFINED");
          return;
        }
        this.audioPlayer.postMessage({
          type: "base64",
          data: jsonData.data.audio,
          isLastData: jsonData.data.status === 2,
        });
        if (jsonData.code === 0 && jsonData.data.status === 2) {
          ttsWS.close();
        }
      };
      ttsWS.onerror = (e) => {
        console.error(e);
      };
      ttsWS.onclose = (e) => {
        // console.log(e);
      };

      return ttsWS;
    },
    getWebSocketUrl(apiKey, apiSecret) {
      var url = "wss://tts-api.xfyun.cn/v2/tts";
      var host = location.host;
      var date = new Date().toGMTString();
      var algorithm = "hmac-sha256";
      var headers = "host date request-line";
      var signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/tts HTTP/1.1`;
      var signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret);
      var signature = CryptoJS.enc.Base64.stringify(signatureSha);
      var authorizationOrigin = `api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`;
      var authorization = btoa(authorizationOrigin);
      url = `${url}?authorization=${authorization}&date=${date}&host=${host}`;
      return url;
    },
    changeBtnStatus(status) {
      this.btnStatus = status;
      // if (status === "UNDEFINED") {
      // 	btnControl.innerText = "立即合成";
      // } else if (status === "CONNECTING") {
      // 	btnControl.innerText = "正在合成";
      // } else if (status === "PLAY") {
      // 	btnControl.innerText = "停止播放";
      // } else if (status === "STOP") {
      // 	btnControl.innerText = "重新播放";
      // }
    },
    onSpeechEnd() {
      // 在这里添加播放结束后的处理逻辑
      console.log("合成语音播放完毕！");
    },
  },
  beforeDestroy() {},
};
</script>
